import { DevTool } from './DevTool/DevTool';
import { HookFormFieldArray } from './FieldArray';
import { FieldControl } from './FieldControl';
import { Form } from './Form';
import { FormConsumer } from './FormConsumer';
import { FormSubmit } from './FormSubmit';
export type { form } from './Form';

import type { ReactHookFormArrayCompound } from './FieldArray';

// type ReactHookForm = typeof Form & {
//   FieldControl: typeof FieldControl;
//   Consumer: typeof FormConsumer;
//   Submit: typeof FormSubmit;
//   Array: ReactHookFormArrayCompound;
// };

export const HookForm = Object.assign( Form, {
  FieldControl,
  Consumer: FormConsumer,
  Submit: FormSubmit,
  Array: HookFormFieldArray,
  DevTool,
} ); // as ReactHookForm;
